import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  BREAKPOINTS,
  DROPDOWN_MBL_BEHAVIOUR,
  DROPDOWN_POSITIONS,
} from '../../../constants';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';

const Dropdown = (props) => {
  const widthToMatch = useMemo(() => {
    switch (props.mobileBehaviour) {
      case DROPDOWN_MBL_BEHAVIOUR.BOTTOM_FROM_MBL_LANDSCAPE:
        return BREAKPOINTS.MBL_LANDSCAPE;
      case DROPDOWN_MBL_BEHAVIOUR.BOTTOM_FROM_TABLET:
        return BREAKPOINTS.TABLET;
      case DROPDOWN_MBL_BEHAVIOUR.NONE:
        return 1;
      default:
        return null;
    }
  }, [props.mobileBehaviour]);
  const matches = widthToMatch && !useMatchesMinWidth(widthToMatch);
  const beta = props.isBeta ? 'dropdown--beta' : '';

  return (
    <>
      {!!props.mobileBehaviour && matches && (
        <div
          className={classNames('dropdown-overlay', {
            'dropdown-overlay--open': props.isOpen,
          })}
        />
      )}
      <div
        className={classNames(
          'dropdown',
          beta,
          {
            'dropdown__navbar': props.position === DROPDOWN_POSITIONS.NAVBAR,
            'dropdown__navbar--login': props.position === DROPDOWN_POSITIONS.LOGIN,
            'dropdown__navbar--secondary':
              props.position === DROPDOWN_POSITIONS.NAVBAR_SECONDARY,

            'dropdown--open': props.isOpen,
            'dropdown--left': props.position === DROPDOWN_POSITIONS.LEFT,
            'dropdown--right': props.position === DROPDOWN_POSITIONS.RIGHT,
            'dropdown--bottom-from-mbl-landscape':
              props.mobileBehaviour ===
              DROPDOWN_MBL_BEHAVIOUR.BOTTOM_FROM_MBL_LANDSCAPE,
            'dropdown--bottom-from-tablet':
              props.mobileBehaviour ===
              DROPDOWN_MBL_BEHAVIOUR.BOTTOM_FROM_TABLET,
          },
          props.className
        )}
        style={props.style}
      >
        {!!props.mobileBehaviour && !!props.mobileLabel && (
          <div className={'dropdown__mbl-header'}>{props.mobileLabel}</div>
        )}
        {props.children}
      </div>
    </>
  );
};

Dropdown.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  position: PropTypes.oneOf([
    DROPDOWN_POSITIONS.CENTER,
    DROPDOWN_POSITIONS.LEFT,
    DROPDOWN_POSITIONS.RIGHT,

    DROPDOWN_POSITIONS.NAVBAR,
    DROPDOWN_POSITIONS.NAVBAR_SECONDARY,
    DROPDOWN_POSITIONS.LOGIN,
  ]).isRequired,
  mobileBehaviour: PropTypes.oneOf([
    DROPDOWN_MBL_BEHAVIOUR.BOTTOM_FROM_MBL_LANDSCAPE,
    DROPDOWN_MBL_BEHAVIOUR.BOTTOM_FROM_TABLET,
    DROPDOWN_MBL_BEHAVIOUR.NONE,
  ]),
  mobileLabel: PropTypes.string,
  onClickOutside: PropTypes.func,
};

Dropdown.defaultProps = {
  position: DROPDOWN_POSITIONS.CENTER,
  onClickOutside: () => { },
};

export { Dropdown };
